interface ILabelProps {
  children: React.ReactNode;
  UNSAFE_className?: string;
}

export const Label: React.FC<ILabelProps> = ({
  children,
  UNSAFE_className = '',
}) => {
  return (
    <span
      className={`${UNSAFE_className} tw-lf-caption-regular tw-w-[-webkit-fill-available] tw-truncate tw-text-center tw-grid-area-[label] desktop:tw-text-left`}
    >
      {children}
    </span>
  );
};
